import * as React from 'react';
import Loader from '../Loader';
import Select from 'antd/lib/select';
import Tooltip from 'antd/lib/tooltip';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { searchStakeholder } from 'src/api/masters';
import { IdLabel } from 'src/components/pages/Container/Interfaces/TypesInShipmentTracking';
import { isValidArray } from 'src/Library/Helper';

interface IProps extends CommonProps {
  apiOptions?: OrgApiParams;
  stakeholderLabel?: string;
  stakeholderKey?: string;
  renderDropdown?: (menu, label, key) => React.ReactElement;
}

interface OrgApiParams {
  type: string;
}

const SelectStakeholder = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    apiOptions,
    placeholder,
    renderDropdown,
    stakeholderKey,
    stakeholderLabel,
  } = props;

  const [orgsOptions, setOrgs] = React.useState<IdLabel[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');

  const handleOrganisationSearch = async () => {
    const response = await searchStakeholder({
      queryString,
      ...apiOptions,
    });
    setOrgs(response?.data || []);
    setSearching(false);
  };

  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    // Only search if there's actually a query string (not on initial mount with empty string)
    if (debounceTime !== undefined && debounceTime !== '') {
      setSearching(true);
      handleOrganisationSearch();
    }
  }, [debounceTime]);

  const dropdownRender = (menu) => {
    if (searching) {
      return <div
        style={{ padding: '25px' }}
      >
        <Loader />
      </div>;
    }
    if (renderDropdown) {
      return renderDropdown(menu, stakeholderLabel, stakeholderKey)
    }
    return menu;
  };

  const renderOrgOptions = () => {
    return orgsOptions?.map((org: IdLabel) => (
      <Select.Option
        key={org.org2Id}
        value={org.org2Id}
      >
        <Tooltip title={org.name} placement="left">
          <div style={{ 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap' 
          }}>
            {org.name}
          </div>
        </Tooltip>
      </Select.Option>
    )) || [];
  };

  const handleStakeholderChange = (stakeholders, options) => {
    if (!onChange) return;

    if (Array.isArray(stakeholders)) {
      
      onChange([ ...stakeholders ]);
    } else {
      if (!options) {
        onChange(options);
      } else {
        onChange({
          ...options?.props,
          ...stakeholders,
        });
      }
    }
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    showSearch
    allowClear
    labelInValue
    value={value}
    disabled={disabled}
    className={className}
    mode={mode || 'default'}
    onChange={handleStakeholderChange}
    filterOption={(inputValue, option) => true}
    dropdownRender={dropdownRender}
    onSearch={query => setQuery(query)}
    onFocus={() => handleOrganisationSearch()}
    placeholder={placeholder || 'Select Stakeholder'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderOrgOptions()}
  </Select>;
};

export default React.memo(SelectStakeholder);